<template>
    <div class="row" ref="tipSliderElement">
        <div class="label">{{ translations.pay.tip }}</div>
    </div>
</template>

<script setup lang="ts">
    import { config } from "@/app/App";
    import { Slider } from "@/app/elements/Slider";
    import { translations } from "@/shared/localization/translations";
    import { onMounted, ref, watch } from "vue";

    const tipSlider = ref<Slider | null>(null);

    const tipSliderElement = ref<HTMLElement | null>(null);

    // define props
    const props = defineProps<{
        tipPercent: number | undefined;
    }>();

    // define emits
    const emit = defineEmits(["update:tipPercent"]);

    onMounted(() => {
        // init tip slider
        const $tipRow = $(tipSliderElement.value! as any);
        tipSlider.value = new Slider(config.maxTip).setValue(props.tipPercent ?? 0).appendTo($tipRow);
        tipSlider.value.onChange = (newValue) => {
            emit("update:tipPercent", newValue);
        };
        tipSlider.value.resize();
    });

    watch(
        () => props.tipPercent,
        (newVal) => {
            if (newVal != tipSlider.value?.getValue()) {
                tipSlider.value!.setValue(newVal!).resize();
            }
        }
    );
</script>

<style lang="scss"></style>
